import React from 'react';
import PropTypes from 'prop-types';

import BubbleContent from 'components/customer/conversation_history/conversation_items_v2/content/bubble_content';
import CompositeMessageItemContent from 'components/customer/conversation_history/conversation_items_v2/automation/composite_message_item_content';
import ConversationItem from 'models/conversation_item';

export default function ChatCompositeContent({ className, item, status }) {
  return (
    <BubbleContent className={className} item={item} status={status}>
      <CompositeMessageItemContent item={item} />
    </BubbleContent>
  );
}

ChatCompositeContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  status: PropTypes.string,
};
